import { api } from './api';
import type {
  ValidatorInfo,
  DelegatorResponse,
  StakingInfo,
} from '@/types/staking';

export const stakingService = {
  /**
   * Fetch all validators with optional status filter
   */
  async getValidators(status?: number): Promise<ValidatorInfo[]> {
    const params = status !== undefined ? { status } : undefined;
    return api.get<ValidatorInfo[]>('/validators', params);
  },

  /**
   * Fetch a single validator by operator address
   */
  async getValidator(operatorAddress: string): Promise<ValidatorInfo> {
    return api.get<ValidatorInfo>(`/validators/${operatorAddress}`);
  },

  /**
   * Fetch delegations for a delegator address
   */
  async getDelegations(delegatorAddress: string): Promise<DelegatorResponse> {
    return api.get<DelegatorResponse>('/delegations', { address: delegatorAddress });
  },

  /**
   * Fetch overall staking information (APR, bonded ratio, etc.)
   */
  async getStakingInfo(): Promise<StakingInfo> {
    return api.get<StakingInfo>('/staking/info');
  },
};
